module.exports = __webpack_public_path__ + "static/media/scandinavian-sam.efa332fa.png";